import React from 'react';
import { object } from 'prop-types';
import {isEmpty} from 'ramda';

import ExternalLink from '../../../ExternalLink';
import LoadingState from '../../../LoadingState';

import s from './PracticeLocation.css';


// @TODO revisit for displaying location specific hours - we will need to figure out a better layout in order for it all to fit
const PracticeLocation = ({ location = {} }) => {

  if (!isEmpty(location)) {

    const renderName = () => {
      if (location.name) {
        return (
          <span className={s.detailsHeader}>
            <span>{location.name}</span>
          </span>
        );
      }

      // Practice name disabled or not provided, return nothing
      return null;
    };

    const renderAddress = () => {

      // Verify a location wants their address shown
      if (location.preferences.showAddress) {
        // Verify all necessary address values have been provided
        if (location.address1 && location.city && location.state && location.postalCode) {
          return (
            <span className={s.item}>
              {location.address1}<br />
              {`${location.city}, ${location.state}, ${location.postalCode}`}
            </span>
          )
        }
      }

      // Address is disabled or all the location values were not provided
      return null;
    };

    const renderPhone = () => {
      if (location.preferences.showPhone && location.phone) {
        return (
          <span className={s.item}>
            P | {location.phone}
          </span>
        );
      }

      // Phone is disabled or phone is not provided
      return null;
    };

    const renderEmail = () => {
      if (location.preferences.showEmail && location.email) {
        return (
          <span className={s.item}>
            E | {location.email}
          </span>
        );
      }

      // Email is disabled or email was not provided
      return null;
    };

    const renderFax = () => {
      if (location.preferences.showFax && location.fax) {
        return (
          <span className={s.item}>
            F | {location.fax}
          </span>
        );
      }

      // Fax is disabled or fax was not provided
      return null;
    };

    const renderUrl = () => {
      if (location.preferences.showUrl && location.url) {
        return (
          <span className={s.item}>
            <ExternalLink
              className={s.externalLink}
              id="location-url"
              label={location.url}
              title={location.url}
              url={location.url}
            />
          </span>
        );
      }

      // Practice url is disabled or url was not provided
      return null;
    };

    const renderHours = () => {

      // Verify a location wants their hours shown
      if (location.preferences.showHours) {
        return (
            <section className={s.vcardBlock}>
              <h4 className={s.heading}>Hours</h4>
              <ul className={s.vcardList}>
                {Object.keys(location.hours).map((day, _) =>
                        <li key={day} className={s.vcardListItem}>
                          <span className={s.child}>{day.substring(0,3) + ': '}</span><span className={s.child}>{location.hours[day]}</span>
                        </li>
                )}
              </ul>
            </section>
        );
      }

      // Address is disabled or all the location values were not provided
      return null;
    };

    return (
      <section className={s.component}>
        <h3 className={s.header}>
          My Location
        </h3>
        <p className={s.details}>
          {renderName()}
          {renderAddress()}
          {renderPhone()}
          {renderEmail()}
          {renderFax()}
          {renderUrl()}
          <br/>
          {renderHours()}
        </p>
      </section>
    );

  }

  // LoadingState until account.location is found
  return (
    <div className={s.message}>
      <p>
        Loading your Practice location...
      </p>
      <LoadingState context="homePagePracticeLocation" />
    </div>
  );

  // @TODO revisit this
  // return (
  //   <section className={s.component}>
  //     <h3 className={s.header}>
  //     </h3>
  //     <p className={s.details}>
  //       There was an error and the map cannot be displayed at this time.
  //     </p>
  //   </section>
  // );

};

PracticeLocation.propTypes = {
  location: object,
};

export default PracticeLocation;



// WEBPACK FOOTER //
// ./src/components/Pages/Home/PracticeLocation/PracticeLocation.js